import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { HeaderData } from 'src/app/_models/header-data';
import { RESULTS_NOT_FOUND, IMAGES } from 'src/app/_common/product-config';
import { Modules } from 'src/app/_common/_enum/module.enum';
import { ClaimService } from 'src/app/_services/claim.service';
import { DatePipe } from '@angular/common';
import { StatusCode } from 'src/app/_common/_enum/module.enum';
import { VCard, VCardEncoding, VCardFormatter } from "ngx-vcard";

@Component({
  selector: 'app-claim-details',
  templateUrl: './claim-details.component.html',
  styleUrls: ['./claim-details.component.scss']
})
export class ClaimDetailsComponent implements OnInit, OnDestroy {
  
  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;
  public selectedItem: string = 'details';
  public claimNumber: string;
  public routerTabLink: string;
  public expandCollapseNotesData: Boolean = true;
  private loading: boolean = false;
  public claimDetails;
  public claimStatus: string;
  private accountLink: string;
  private claimDetailsfromStorage: any;
  private notes: any;
  private selectedNote: any;
  public resultsNotFound: any = RESULTS_NOT_FOUND;
  public images: any = IMAGES;
  private hasAccess: boolean = true;
  private hasAccessNotes: boolean = true;
  private reportLoading: boolean = false;
  private showLossRunButton: boolean = true;
  public vCardEncoding: typeof VCardEncoding = VCardEncoding;
  public vCardString: any = [];
  private genericAdjuster = {
    adjusterName: "Coaction Team",
    adjusterPhone: '(800) 774-2755',
    adjusterEmail: 'claims@coactionspecialty.com',
    adjusterTitle: 'Claims Department',
    adjusterCompany: 'Coaction Specialty Insurance',
    adjusterWebsite: 'www.coactionspecialty.com',
    adjusterBase64Image: this.images.adjusterImage
  }

  @ViewChild("lossRunErrorModal", {static: false}) lossRunErrorModal;
  @ViewChild("lossRunMessageModal", {static: false}) lossRunMessageModal;

  constructor(private readonly route: ActivatedRoute, private readonly router: Router, private claimService: ClaimService) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.claimNumber = params.get("id").toString();
    });

    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */
    this.setClaimDetailsData();

    this.routerTabLink = '/claims/' + this.claimNumber;
  }

  setHeaderData(details?: any){
    let pipe = new DatePipe('en-US');
    this.headerData.pageTitle = this.claimNumber;
    if(details){
      this.headerData.breadcrumb = [{ itemName: details.accountName, itemLink: this.accountLink}, {itemName:"Claims", itemLink:""}];
      if(details.status === 'Closed') {
        this.headerData.detailMenu = [
          {label: "Date Reported", description: pipe.transform(details.dateReported, 'MM/dd/yyyy')}, 
          {label: "Date of Loss", description: pipe.transform(details.dateOfLoss, 'MM/dd/yyyy')}, 
          {label: "Date Closed", description: pipe.transform(details.dateClosed, 'MM/dd/yyyy')},
          {label: "Status", description: details.status, descClass: "psi-detail-status closed"}];
      } else {
        this.headerData.detailMenu = [
          {label: "Date Reported", description: pipe.transform(details.dateReported, 'MM/dd/yyyy')}, 
          {label: "Date of Loss", description: pipe.transform(details.dateOfLoss, 'MM/dd/yyyy')},
          {label: "Status", description: details.status, descClass: "psi-detail-status open"}];
      }
    }
    this.claimService.header = this.headerData;
  }

  setClaimHeader(_claimDetails: any) {
    this.claimDetails = _claimDetails;
    if(this.claimDetails) {
      if(_claimDetails.accountId){
        this.accountLink = "/accounts/" + _claimDetails.accountId + "/policies";
      }
      this.setHeaderData(this.claimDetails);   /* Setting Headers */
    }
  }

  get ModuleEnum(){
    return Modules;
  }

  fetchClaimDetails () {
    this.loading = true;
    this.hasAccess = true;
    let claimDetailsSubscription = this.claimService.fetchClaimDetails(this.claimNumber).subscribe(response => {
        this.loading = false;
        this.setClaimHeader(response);
        this.claimService.storeClaimData(this.claimDetails);
    },error=>{
        this.loading = false;
        this.hasAccess = !(error.status == StatusCode.NoAccess);
    });

    this.claimService.runningServices.push(claimDetailsSubscription);
  }

  /*
    * Steps for below function
    * First it gets data from session storage and sets in this.claimDetailsfromStorage
    * Then it will set initial header data so that we don't see blank header with no breadcrumb information
    * Then it checks if there is financial data in session storage variable (this.claimDetailsfromStorage) 
    * and if its undefined it makes an API call to fetch data 
    * Else it will pull policy details from session storage variable this.claimDetailsfromStorage
  */
  setClaimDetailsData() {
    this.loading = false;
    this.claimService.runningServices.forEach(subscription =>subscription.unsubscribe());
    // Getting Policy data from session storage
    this.claimDetailsfromStorage = this.claimService.getClaimData();

    if(this.claimDetailsfromStorage && this.claimNumber === this.claimDetailsfromStorage.claimNumber) {
      this.setClaimHeader(this.claimDetailsfromStorage); // sets initial header data only

      if (!this.claimDetailsfromStorage.financialSummary && this.claimDetailsfromStorage.financialSummary !== "undefined") {
        this.fetchClaimDetails();
      }else{
        this.claimDetails = this.claimDetailsfromStorage;
        this.setClaimHeader(this.claimDetailsfromStorage); // sets initial header data only
      }
    } else {
      /*this.claimDetailsfromStorage = null;
      this.claimService.storeClaimData(this.claimDetailsfromStorage);*/
      this.fetchClaimDetails();
    }
  }

  fetchClaimNotes() {
    this.claimService.runningServices.forEach(subscription =>subscription.unsubscribe());
    this.loading = true;
    let claimNotesSubscription = this.claimService.fetchClaimNotes(this.claimNumber).subscribe(response => {
      this.loading = false;
      this.notes = response && response.notes;
      this.hasAccessNotes = true;
      if(this.notes){
        this.notes.forEach(note => {
          note.isSelected = false;
        });
        this.claimService.storeClaimNotesData(this.notes);
        if(this.notes.length > 0) {
          this.openNote(this.notes[0], this.notes);
        }        
      }
    },error=>{
      this.loading = false;
      this.hasAccessNotes = !(error.status == StatusCode.NoAccess);
    });
    
    this.claimService.runningServices.push(claimNotesSubscription);
  }

  openAdjustersTab() {
    console.log("In Adjuster Tab function!!!!");
    this.selectedItem = 'adjuster';
    this.showLossRunButton = false;
    this.loading = false;
    this.claimService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }

  openNote(_selectedNote, _allNotes) {
    _allNotes.forEach(note => {
      note.isSelected = false;
    });
    this.selectedNote = _selectedNote;
    this.selectedNote.isSelected = true;
  }

  downloadLossRunReport(type: string){
    this.reportLoading = true;
    let number = type === "policy" ? this.claimDetails.policyNumber : this.claimDetails.accountId;
    this.claimService.openModal('none', this.lossRunMessageModal);

    this.claimService.downloadLossRunReport(number, (type+"Number")).subscribe(data=>{
      this.reportLoading = false;
      this.claimService.closeModal();
    },
    error => {
      this.reportLoading = false;
      let hasOpenModals = this.claimService.hasOpenModals();
      if (hasOpenModals) {
        this.claimService.closeModal();
      }
      if(error.status == StatusCode.NoAccess) {        
        setTimeout(() => {
          this.claimService.openModal('none', this.lossRunErrorModal);
        }, 50);        
      }
      
      if(error.status == StatusCode.InternalServer) {
        setTimeout(() => {
          this.claimService.openModal('error', 'none');
        }, 50);
      }
      console.warn("Download Loss Run Report Error : " + error);
    });
  }

  downloadVCard(_adjuster, idx) {
    let vCard: VCard;
    let _name  = _adjuster.adjusterName.split(' ');
    vCard = {
      name: { firstNames: _name[0], lastNames: _name[1] },
      telephone: [{value: _adjuster.adjusterPhone || this.genericAdjuster.adjusterPhone, param: { type: 'work' }}],
      email: [{value: _adjuster.adjusterEmail || this.genericAdjuster.adjusterEmail, param: { type: 'work' }}],
      photo: { value: _adjuster.adjusterBase64Image || this.genericAdjuster.adjusterBase64Image, param: { mediatype: 'image/jpeg;base64' } },
      title: _adjuster.adjusterTitle || this.genericAdjuster.adjusterTitle,
      organization: this.genericAdjuster.adjusterCompany,
      url: this.genericAdjuster.adjusterWebsite
    }

    this.vCardString[idx] = VCardFormatter.getVCardAsString(vCard);

    return vCard;
  }

  ngOnDestroy() {
    this.claimService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}
